import { Cell, Pie, PieChart, ResponsiveContainer } from 'recharts';

const PercentageCircle = ({ percentage = 45 }) => {
  const size = 132;

  const data = [
    { name: 'completed', value: percentage },
    { name: 'remaining', value: 100 - percentage },
  ];

  const COLORS: Record<string, string> = {
    completed: '#FF5C33',
    remaining: '#F2F2F3',
  };

  return (
    <div className="relative flex items-center justify-center">
      <div className="h-[8.25rem] w-[8.25rem]">
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Pie
              data={data}
              cx="50%"
              cy="50%"
              startAngle={90}
              endAngle={450}
              innerRadius={size * 0.35}
              outerRadius={size * 0.45}
              paddingAngle={0}
              dataKey="value"
            >
              {data.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={COLORS[entry.name]} stroke="none" />
              ))}
            </Pie>
          </PieChart>
        </ResponsiveContainer>

        <div className="absolute inset-0 flex items-center justify-center">
          <span className="typography-product-heading-compact-desktop">{percentage}%</span>
        </div>
      </div>
    </div>
  );
};

export default PercentageCircle;
